import React, { useState } from "react";
import { api, formatApiError, STATUS_LABELS, STATUS_CHIP, formatDateTimeTR } from "../lib/apiClient";
import { PageHeader } from "../components/Layout";
import { Search, ArrowRight } from "lucide-react";
import { toast } from "sonner";

const ACTION_LABELS = {
  ORDER_CREATED: "Sipariş Oluşturuldu",
  LABEL_PRINTED: "Etiket Yazdırıldı",
  STATUS_CHANGE: "Durum Değişikliği",
  ASSIGNED_TO_SHIPMENT: "Sevkiyata Atandı",
  SHIPMENT_SCAN: "Sevkiyat Taraması",
};

export default function HistoryPage() {
  const [barcode, setBarcode] = useState("");
  const [rows, setRows] = useState(null);

  const search = async (e) => {
    e?.preventDefault?.();
    try {
      const { data } = await api.get("/history", { params: barcode ? { barcode } : {} });
      setRows(data);
    } catch (err) { toast.error(formatApiError(err)); }
  };

  const loadAll = async () => {
    setBarcode("");
    try {
      const { data } = await api.get("/history");
      setRows(data);
    } catch (err) { toast.error(formatApiError(err)); }
  };

  return (
    <div>
      <PageHeader title="Üretim Geçmişi" subtitle="Barkod bazlı olay kaydı" />

      <form onSubmit={search} className="flex gap-2 mb-4">
        <div className="relative flex-1 max-w-md">
          <Search size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <input
            data-testid="history-search"
            value={barcode}
            onChange={(e) => setBarcode(e.target.value)}
            placeholder="Barkod ile ara..."
            className="w-full pl-10 pr-4 py-3 bg-white border border-slate-300 rounded-none focus:border-blue-700 focus:outline-none font-mono"
          />
        </div>
        <button type="submit" className="px-5 py-3 bg-blue-700 text-white font-bold uppercase text-sm">Ara</button>
        <button type="button" onClick={loadAll} className="px-5 py-3 border-2 border-slate-800 hover:bg-slate-800 hover:text-white font-bold uppercase text-sm">Son 500</button>
      </form>

      {rows === null && <div className="text-slate-500">Bir barkod arayın veya son 500 kaydı yükleyin.</div>}
      {rows && rows.length === 0 && <div className="text-slate-500">Kayıt bulunamadı.</div>}
      {rows && rows.length > 0 && (
        <div className="card-industrial overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-slate-100 border-b border-slate-300 text-xs uppercase tracking-widest text-slate-600">
                <th className="text-left px-4 py-3">Zaman</th>
                <th className="text-left px-4 py-3">İşlem</th>
                <th className="text-left px-4 py-3">Durum Değişimi</th>
                <th className="text-left px-4 py-3">Kullanıcı</th>
                <th className="text-left px-4 py-3">Barkod / Detay</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={r.id} className={`border-b border-slate-200 ${i % 2 === 0 ? "bg-white" : "bg-slate-50"}`}>
                  <td className="px-4 py-2 font-mono tabular-nums whitespace-nowrap">{formatDateTimeTR(r.timestamp)}</td>
                  <td className="px-4 py-2 font-bold">{ACTION_LABELS[r.action] || r.action}</td>
                  <td className="px-4 py-2">
                    <div className="flex items-center gap-1 flex-wrap">
                      {r.prev_status && <span className={STATUS_CHIP[r.prev_status]}>{STATUS_LABELS[r.prev_status]}</span>}
                      {r.prev_status && r.new_status && <ArrowRight size={12} className="text-slate-400" />}
                      {r.new_status && <span className={STATUS_CHIP[r.new_status]}>{STATUS_LABELS[r.new_status]}</span>}
                    </div>
                  </td>
                  <td className="px-4 py-2">{r.user_name}</td>
                  <td className="px-4 py-2 font-mono text-xs text-slate-600">{r.extra?.barcode || ""} {r.extra?.note && <span className="italic">— {r.extra.note}</span>}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
